export default __webpack_public_path__ + "static/hover-do-ed7d5b50b3bb4657d8ba680819008a5e.png";